import { ConfigFromResponse } from "config/service/ConfigFromResponse";
import defaultConfigService from "config/service/ConfigService";
import { ConfigService } from "config/service/ConfigService";
import { DefaultRequestStatus, RequestStatus } from "ecom-teams-apps-core";
import { action, makeObservable } from "mobx";
import { Config } from "shared/models/Config";

export interface ConfigStore {
    config: Config | null;

    loadConfigRequestStatus: RequestStatus;

    loadConfig: () => void;
}

export class DefaultConfigStore implements ConfigStore {
    constructor(private configService: ConfigService, private loadConfigReqStatus: RequestStatus) {
        makeObservable(this, {
            loadConfig: action,
        });
    }

    public config: Config | null = null;

    public get loadConfigRequestStatus() {
        return this.loadConfigReqStatus;
    }

    public async loadConfig() {
        const config = await this.loadConfigReqStatus.handleAnyRequest(() => this.configService.getConfig());

        if (config) {
            this.config = new ConfigFromResponse(config).config();
        }
    }
}

export default new DefaultConfigStore(defaultConfigService, new DefaultRequestStatus());
